import { Button } from '@design-system/components/button/button';
import { Modal } from '@design-system/components/modal/modal';
import { Typography } from '@design-system/components/typography/typography';
import { Tag } from '@design-system/components/tag/tag';
import { Col, Row } from '@design-system/components/grid/grid';
import { button, tag, wrapper } from './FreeOffersModal.css';
import { HomeVM } from '../home.viewModel';

type FreeOffersModalProps = HomeVM['freeOffersModal'];

export const FreeOffersModal = (props: FreeOffersModalProps) => (
  <Modal
    isOpen={props.isOpen}
    onClose={props.close}
    modalClassName="w-full md:w-[742px]"
    contentClassName="w-full h-full gap-0"
    largeTitle
    centerContent
    disableBackdropClick
  >
    <Col center gap="xl" className={wrapper}>
      <Col center gap="l">
        <Tag label="New feature" className={tag} readonly />
        <Typography variant="headline" size="large">
          Free Offers are here!
        </Typography>
        <Typography variant="body" size="large" fontWeight="normal">
          Draw in more audience with free content to enhance engagement and
          speed up your growth!
        </Typography>
      </Col>
      {/* TODO: add video here */}
      <Row>
        {/* TODO: update Learn More link */}
        <a
          href="https://help.playbookapp.io/en/articles/9698798-exclusive-subscription-strategy-pricing-and-packaging"
          target="_blank"
          rel="noreferrer"
        >
          <Button variant="text" color="primary" className={button}>
            Learn More
          </Button>
        </a>
        <Button color="neutral" onClick={props.redirect} className={button}>
          Go to Offers
        </Button>
      </Row>
    </Col>
  </Modal>
);
